module.exports = __webpack_public_path__ + "static/jawline-before-97f7daf65c11d902bc83057db0bae20b.jpg";